<template>
  <div class="page">
    <Header title="分类" />
    <div class="sort-nav">
      <!-- <div class="sort-nav-btn">全部分类</div> -->
      <van-dropdown-menu>
        <van-dropdown-item title="全部分类" ref="item">
          <div class="sort-item-box">
            <div class="sort-item" v-for="(categoryItem,index) in categoryList" :key="index" ng-click="category(categoryItem)">
                <div style="padding-top: 0.5rem; text-align: center">
                    <img :src="getImgUrl(categoryItem.imageUri)" style="width: auto;height: 0.8rem;">
                </div>
                <div class="themecolor" style="text-align: center;">{{categoryItem.categoryName}}</div>
            </div>
            <div class="sort-block"></div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      <div class="sort-nav-btn" @click="queryItemList('tag')">{{tagList[0]&&tagList[0].tagName}}</div>
    </div>

  <div class="list-box">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="integration-detail-item" v-for='(item,index) in itemList' :key="index" @click="gotoWeb('goods-detail',item)">
        <div class="search-result-l">
            <img class="search-result-img" :src="getImgUrl(item.itemImageUri)" alt="">
        </div>
        <div class="search-result-txt">
            <h1 class="search-result-title singleLine-ellipsis">{{item.itemName}}</h1>
            <div class="search-result-introduction color999 singleLine-ellipsis">{{item.briefIntro}}</div>
            <div class="clearfix">
                <div class="search-result-integration">
                    <span class="search-result-newintegration"  v-if ='item.isPromotion == 0'>{{item.exchangePoint}}积分</span>
                  <span class="search-result-newintegration" v-if ='item.isPromotion == 1'>{{item.promotionPoint}}积分 <span class="search-result-oldintegration">{{item.exchangePoint}}积分</span></span>
                </div>
                <div class="search-result-inventory color999 pull-right" v-if="!isCourseItem(item)">
                    库存：
                    <span v-if="item.logicalStock > 0">{{item.logicalStock}}</span>
                    <span v-if="item.logicalStock <= 0">{{item.usableStock}}</span>
                </div>
                <div class="search-result-inventory color999 pull-right" v-if="isOfflineCourse(item)">
                  <span v-if="isCourseCutoff(item)" style="color: red">已截止</span>
                </div>
                <div class="search-result-inventory color999 pull-right" v-if="isOnlineCourse(item)">
                  <span>评分：{{ item.courseScore }}</span>
                </div>
            </div>
            <div v-if="isOfflineCourse(item)" class="row" style="font-size: 12px;">
              <div class="col-20" style="padding-left: 0.1rem; text-align: right;">{{ item.courseLocation }}</div>
            </div>
            <div v-if="isOnlineCourse(item)" class="row" style="font-size: 12px;">
              <div class="col-80">课时：{{ item.lessonPeriod }} </div>
            </div>
        </div>
      </div>
    </van-list>
  </div>

    <tabbar :active="1"></tabbar>
  </div>
</template>

<script>
import Header from '@/components/header'
import sortApi from '@/api/sort'
import Tabbar from '../../components/tabbar.vue'
export default {
  name: 'HomeMain',
  components: {
    Header,
    Tabbar
  },
  data () {
    return {
      value: 0,
      switch1: false,
      switch2: false,
      option: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 }
      ],
      params: {
        page: 1,
        pageSize: 20,
        recordTimeFrom: '',
        recordTimeTo: '',
        pointType: ''
      },
      page: 1,
      categoryList: [],
      tagList: [],
      itemList: [],
      loading: false,
      finished: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    onConfirm () {
      this.$refs.item.toggle()
    },
    getImgUrl (uri) {
      return process.env.VUE_APP_FILE_SERVER + uri
    },
    onLoad () {
      this.params.page = this.page
      this.queryItemList()
      this.page++
    },
    init () {
      this.queryItemCategoryList()
      this.queryItemTagShowInCategoryList()
      this.queryItemList()
    },
    queryItemCategoryList () {
      sortApi.queryItemCategoryList().then(res => {
        if (res.data.resultCode === '0') {
          this.categoryList = res.data.resultData.categoryList
        }
      })
    },
    queryItemTagShowInCategoryList () {
      sortApi.queryItemTagShowInCategoryList().then(res => {
        if (res.data.resultCode === '0') {
          this.tagList = res.data.resultData.tagList
          console.log(res.data.resultData.tagList)
        }
      })
    },
    queryItemList (type) {
      if (type) {
        this.params.tagId = this.tagList[0].tagId
      }
      sortApi.queryItemList(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.itemList = res.data.resultData.itemList
        }
      })
    },
    gotoWeb (type, item) {
      if (type === 'goods-detail') {
        this.$router.push({ name: 'goods-detail', query: { itemId: item.itemId } })
      } else if (type === 'tssUrl') {
        window.open('https://rbaatssuat.uxicp.com/portal/')
      }
    },
    isOfflineCourse (item) {
      return item && item.itemCategory && item.itemCategory.categoryCode === '1031'
    },
    isOnlineCourse  (item) {
      return (item && item.itemCategory && item.itemCategory.parentList &&
        item.itemCategory.parentList.length && item.itemCategory.parentList[0].categoryCode === '1032') || (item && item.itemCategory &&
        (item.itemCategory.categoryCode === '13003' || item.itemCategory.categoryCode === '501'))
    }
  }
}
</script>

<style scoped lang="less">
.van-dropdown-menu{
  width: calc(100vw - 96px);
}
.sort-nav{
  display: flex;
  width: 100vw;
  position: fixed;
  border-bottom: 1px solid #ccc;
}
.list-box{
  margin-top:50px;
}
.sort-nav-btn{
  height: 48px;
  background-color: #fff;
  text-align: center;
  align-items: center;
  width: 110px;
  line-height: 48px;
}

.shadow-mask-modal-wrapper{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    /* height: 100%; */
    background-color: rgba(0,0,0,.4);
    z-index: 9;
}
.sort-item-box{
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  margin-left: 5%;
}
.sort-block{
  height: 20px;
  width: 100%;
}
.sort-item{
  margin-bottom:10px;
  width: 33%;
  font-size: 12px;
  img{
    width: 35px;
    margin-bottom: 5px;
  }
}

.integration-detail-item{
  display: flex;
  width: 96%;
  background-color: #fff;
  margin-bottom: 5px;
  padding:5px 2%;
}
.search-result-l{
  width: 80px;
  .search-result-img{
      width: 70px;
      height: 70px;
      background-color: #f1f1f1;
  }
}
.search-result-txt{
  width: 75vw;
  .search-result-title{
    font-size: 14px;
  }
}

.search-result-item{
    height: 1.5rem;
    padding-top: 0.1rem !important;
    padding-bottom: 0.1rem !important;
    margin-bottom: 0.1rem;
    background-color: #fff;
}
.search-result-item .search-result-l{
    height: 100%;
}
.search-result-item .search-result-txt{
    padding-left: 0.2rem;
}
.search-result-item .search-result-title{
    font-size: 0.24rem;
    color: #04424a;
}
.search-result-introduction{
    margin-bottom: 0.1rem;
    font-size: 0.2rem;
}
.search-result-newintegration{
    color: #e20015;
    font-size: 0.3rem;
    font-weight: bold;
}
.search-result-oldintegration{
    color: #c2c2c2;
    font-size: 0.24rem;
    text-decoration: line-through;
}
.search-result-inventory{
    font-size: 0.24rem;
}

</style>
